<template>
	<div id="app">
		<header class="active">
			<div class="container-fluid page-header">
				<nav class="navbar navbar-expand-xll navbar-light">
					<a class="navbar-brand logo_white" href="#"></a>
					<div class="navbar-collapse collapse" >
						<ul class="navbar-nav">
							<li class="nav-item active" :class="isActive == navIdx ? 'show' : '' "
								v-for="(nav, navIdx) in navs" :key="navIdx" @click="handleNav(navIdx)">
								<a class="nav-link link active" :href="nav.anchor" target="_self">{{nav.label}}</a>
							</li>
						</ul>
					</div>
				</nav>
			</div>
		</header>
		<main class="homepage">
			<div class="swiper-container index-swiper">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(banner, banIdex) in banners" :key="banIdex">
						<img :src="bannerUrl(banner)" alt="">
					</div>
				</div>
				<div class="swiper-button-prev"></div>
				<div class="swiper-button-next"></div>
			</div>

			<!-- 关于我们 -->
			<div class="container-fluid about-us position-relative">
				<div id="aboutUs" class="md-title position-absolute"></div>
				<div class="row">
					<div class="col-lg-5 offset-lg-1 col-md-12">
						<div class="d-flex flex-column">
							<div class="title">
								<img src="./assets/imgs/title1.png" alt="">
								<span>ABOUT US</span>
							</div>
							<h3>南京戎智信息创新研究院</h3>
							<div class="subtitle">— 新型研发机构</div>
							<div class="content">
								<p>
									戎智研究院依托南京大学、南京江北新区、南京工业互联网产业联盟等单位，是南京市科技局认定备案的市级新型研发机构。主要从事新型传感和工业互联网的研究和开发，推动科技成果转化。核心团队来自于南京大学和多家上市公司，基于深厚的先进感知技术背景和
									IT 技术积累，公司在工业互联网、物联网等业务领域深耕力做，主要业务方向为先进传感和互联网技术的研发与应用。
								</p>
								<p>
									新型研发机构以技术人才为主体，以市场需求为导向，采用全新模式推动产学研发展，助力南京市产业转型升级。戎智研究院在咨询、规划、实施、服务等环节形成了标准化的解决方案，能够在提供标准化服务及配套软硬件的基础上，根据客户的行业特点和业务模式，深入挖掘客户需求，为客户定制差异化的解决方案。
								</p>
							</div>
						</div>
					</div>
					<div class="col-lg-5 col-md-12 us-img d-flex align-items-center justify-content-center">
						<img src="./assets/imgs/gs2.png">
					</div>
				</div>
			</div>

			<div class="container-fluid ljrw position-relative">
				<div id="ljrw" class="md-title position-absolute"></div>
				<div class="row-title">
					<p class="title">领军人才</p>
					<p class="subtitle">—— LEADING TALENTS ——</p>
				</div>

				<div class="row one" style="margin-top: 80px;">
					<div class="col-12 col-sm-10 offset-sm-1 d-flex flex-wrap main">
						<div class="col-lg-6 col-md-12 d-flex align-items-center justify-content-end">
							<div class="col-5 d-flex justify-content-center avatar-wrapper">
								<img class="avatar" src="@/assets/imgs/face1@2x.png" alt="">
							</div>
							<div class="col-md-7 intro">
								<div class="username">
									施 毅
									<span>研究院院长</span>
								</div>
								<div class="title">南京大学教授、博士生导师</div>
								<div class="title">国家杰出青年基金获得者</div>
								<div class="title">长江学者特聘教授</div>
								<div class="title">国家重大科学研究计划首席科学家</div>
							</div>
						</div>
						<div class="col-lg-6 col-md-12 content">
							<p>施毅教授主持和承担了二十多项国家自然科学基金、“973”和“863”等研究课题，
								包括主持国家重大科学研究计划“纳米研究”项目；发表和合作发表SCI学术论文300余篇，
								申请/获得国家发明专利40余项；有关研究成果曾荣获国家自然科学二等奖和国家技术发明三等奖各1项，
								省部级科技进步一等奖1项。
							</p>
							<p>2019年，施教授牵头发起戎智信息创新研究院，并任院长。</p>
						</div>
					</div>
				</div>

				<div class="row two" style="margin-top: 20px;">
					<div class="col-12 col-sm-10 offset-sm-1 d-flex flex-wrap main">
						<div class="col-lg-6 col-md-12 content">
							<p> 郑有炓院士长期致力于半导体异质结构材料、器件及物理研究，在III族氮化物异质结构、锗硅异质结构和硅基纳米结构材料及器件应用研究上，取得系列创新成果，跻身于国际前列。发表SCI论文400余篇，有关研究成果荣获国家自然科学二等奖1项、江苏省科学技术奖一等奖2项、国家技术发明三等奖1项，国防科工委光华科技基金一等奖及国家863计划先进工作者一等奖。
							</p>
							<p>2003年，当选为中国科学院院士。</p>
							<p> 2019年，郑院士参与发起戎智信息创新研究院，并任研究院首席科学家。</p>
						</div>
						<div class="col-lg-6 col-md-12 d-flex intro-img">
							<div class="col-md-7 intro">
								<div class="username">
									郑有炓
									<span>首席科学家</span>
								</div>
								<div class="title">中国科学院院士</div>
								<div class="title">南京大学教授、博士生导师</div>
								<div class="title">国家重大研究计划信息科学领域专家咨询组副组长</div>
							</div>
							<div class="col-5 d-flex justify-content-center avatar-wrapper">
								<img class="avatar" src="@/assets/imgs/face2@2x.png" alt="">
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 业务领域 -->
			<div class="container-fluid ywly position-relative">
				<div id="ywly" class="md-title position-absolute"></div>
				<div class="row-title">
					<p class="title">业务领域</p>
					<p class="subtitle">—— BUSINESS AREA ——</p>
				</div>
				<div class="row" style="margin-top: 80px;">
					<div class="col-sm-10 col-sx-10 swiper-container swipers innovate-swiper2">
						<div class="swiper-wrapper">
							<div class="swiper-slide d-flex align-items-center">
								<img src="@/assets/imgs/01.png">
								<div class="d-flex flex-column justify-content-center">
									<p class="title">
										<span style="margin-right: 5px;">智慧感知</span>
									</p>
									<p>
										以微结构新材料为基础，进行相关传感器间的研究与开发，包括柔性压力/温度传感器，电子皮肤，触觉传感器件及系统，可穿戴电子材料与器件和生物医学电子器件等。利用柔性传感器和导电体，可以将外界的受力或受热情况转换为电信号，传递给机器人的电脑进行信号处理，以便实时精准地监测出人体各项指标。
									</p>
								</div>
							</div>
							<div class="swiper-slide d-flex align-items-center">
								<img src="@/assets/imgs/02.png">
								<div>
									<p class="title">
										<span style="margin-right: 5px;">泛在物联</span>
									</p>
									<p>
										面向智慧中医的脉象采集和脉诊大数据的机器学习分析与病情推测的共性方法与关键技术，重点突破柔性压力传感器工程化问题，实现超大量程和高可靠性的脉象采集模块，并着力提高并改善物联网的可接入性能、数据处理性能、数据保护性能为实现中医脉象数据的实时快速传输提供高效平台。
									</p>
								</div>
							</div>
							<div class="swiper-slide d-flex align-items-center">
								<img src="@/assets/imgs/03.png">
								<div>
									<p class="title">
										<span style="margin-right: 5px;">工业互联</span>
									</p>
									<p>
										结合企业、区域产业特点，帮助企业、区域行业、产业集群、园区建设工业互联网平台，提供从IaaS、PaaS到SaaS应用整体解决方案，工业互联网平台可为区域内企业提供设备上云、商品交易、能力交易、协同设计、企业上云、供应链金融、产业指数分析、专家对接服务等共性基础服务。
									</p>
								</div>
							</div>
							<div class="swiper-slide d-flex align-items-center">
								<img src="@/assets/imgs/04.png">
								<div>
									<p class="title">
										<span style="margin-right: 5px;">规划咨询</span>
									</p>
									<p>
										结合企业、区域产业特点，帮助企业、区域行业、产业集群、园区制定工业互联网平台整体规划，明确平台定位、参考架构、标准体系、运营推广方式等，组织面向政府人员、企业管理层的培训，协助建立区域产业联盟组织及企业各类工业互联网专项申报材料的编制。
									</p>
								</div>
							</div>
						</div>
						<div class="swiper-button-prev"></div>
						<div class="swiper-button-next"></div>
					</div>
				</div>
			</div>


			<!-- 我们的优势 -->
			<div class="container-fluid wdys position-relative">
				<div id="wdys" class="md-title position-absolute"></div>
				<div class="row-title">
					<p class="title">我们的优势</p>
					<p class="subtitle">—— OUR ADVANTAGE ——</p>
				</div>
				<div class="row" style="margin-top: 130px;">
					<div class="col-10 offset-1">
						<div class="row item-wrapper d-flex justify-content-between flex-wrap">
							<div class="item">
								<img src="./assets/imgs/icon1@2x.png" alt="">
								<div class=" d-flex flex-column justify-content-center align-items-center">
									<p class="d-flex align-items-center title">研发优势</p>
									<p class="d-flex align-items-center info">依托南京大学和国防重点学科实验室</p>
								</div>
							</div>
							<div class=" item">
								<img src="./assets/imgs/icon2@2x.png" alt="">
								<div class=" d-flex flex-column justify-content-center align-items-center">
									<p class="d-flex align-items-center title">专业优势</p>
									<p class="d-flex align-items-center info">对集成电路产业和工业互联网的深度理解</p>
								</div>
							</div>
							<div class=" item">
								<img src="./assets/imgs/icon3@2x.png" alt="">
								<div class=" d-flex flex-column justify-content-center align-items-center">
									<p class="d-flex align-items-center title">生态优势</p>
									<p class="d-flex align-items-center info">具备完备的产业生态体系</p>
								</div>
							</div>
							<div class="item">
								<img src="./assets/imgs/icon4@2x.png" alt="">
								<div class=" d-flex flex-column justify-content-center align-items-center">
									<p class="d-flex align-items-center title">交叉学科优势</p>
									<p class="d-flex align-items-center info">融合新一代信息技术和产业</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 新闻中心 -->
			<div class="container-fluid news position-relative">
				<div id="news" class="md-title position-absolute"></div>
				<div class="row-title">
					<p class="title">新闻中心</p>
					<p class="subtitle">—— NEWS CENTER ——</p>
				</div>
				<div class="row" style="margin-top: 80px;">
					<div class=" col-12 col-md-5 offset-md-1 text-center mzy d-flex align-items-center">
						<a class="position-relative" href="https://mp.weixin.qq.com/s/HcFEcBUgCuN5Yu-0M5eiHQ"
							target="_blank">
							<img src="./assets/imgs/mzy01.jpg" alt="">
							<div class="desc">我院科研成果在国际重要学术期刊《IEEE Sensors Journal》刊发</div>
						</a>
					</div>
					<div class="col-12 col-md-6 overflow-hidden news-wrapper">
						<div class="swiper news-swiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<a href="https://mp.weixin.qq.com/s/Cj0kAYdDLmPXtNGh7ad_rw" target="_blank"
										class="d-flex align-items-center news-detail">
										<div class="left d-flex flex-column justify-content-center align-items-center">
											<span>15</span>
											<span>2022-06</span>
										</div>
										<div class="right">
											<p class="text-ellipsis">工业企业数据治理建设趋势</p>
											<p class="text-ellipsis-2">结合大型集团数据治理实践经验，总结数据治理建设的六个关键点和八大建设趋势</p>
										</div>
									</a>
								</div>
								<div class="swiper-slide">
									<a href="https://mp.weixin.qq.com/s/HcFEcBUgCuN5Yu-0M5eiHQ" target="_blank"
										class="d-flex align-items-center news-detail">
										<div class="left d-flex flex-column justify-content-center align-items-center">
											<span>30</span>
											<span>2022-05</span>
										</div>
										<div class="right">
											<p class="text-ellipsis">我院科研成果在国际重要学术期刊刊发</p>
											<p class="text-ellipsis-2">我院科研团队在《IEEE Sensors
												Journal》上发表论文，该期刊在传感器研究领域属于重要影响期刊。</p>
										</div>
									</a>
								</div>
								<div class="swiper-slide">
									<a href="https://mp.weixin.qq.com/s/L27GL85i-Oez7_3YfV-GiQ" target="_blank"
										class="d-flex align-items-center news-detail">
										<div class="left d-flex flex-column justify-content-center align-items-center">
											<span>06</span>
											<span>2022-04</span>
										</div>
										<div class="right">
											<p class="text-ellipsis">企业数字化转型规划设计</p>
											<p class="text-ellipsis-2">企业数字化转型规划设计 107P【附下载】</p>
										</div>
									</a>
								</div>
								<div class="swiper-slide">
									<a href="https://mp.weixin.qq.com/s/AOgKEE_mmeMoZb2kmu_RsQ" target="_blank"
										class="d-flex align-items-center news-detail">
										<div class="left d-flex flex-column justify-content-center align-items-center">
											<span>15</span>
											<span>2021-12</span>
										</div>
										<div class="right">
											<p class="text-ellipsis">工业互联网标识解析应用案例汇编</p>
											<p class="text-ellipsis-2">
												工业互联网标识解析体系建设自2018年推行建设以来，工业互联网标识解析的技术探索及应用已取得阶段性成果。</p>
										</div>
									</a>
								</div>
								<div class="swiper-slide">
									<a href="https://mp.weixin.qq.com/s/4S6BfItmmum9f9B1miUFXQ" target="_blank"
										class="d-flex align-items-center news-detail">
										<div class="left d-flex flex-column justify-content-center align-items-center">
											<span>22</span>
											<span>2020-01</span>
										</div>
										<div class="right">
											<p class="text-ellipsis">我院成为AII成员单位</p>
											<p class="text-ellipsis-2">戎智研究院成为工业互联网产业联盟第三十七批成员单位</p>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>

		<footer>
			<div class="container-fluid page-footer position-relative contact" id="contact">
				<div class="row detail h-100">
					<div class="col-6 col-sm-4 d-flex justify-content-center">
						<div>
							<div class="title">快速导航</div>
							<div class="d-flex flex-wrap">
								<a href="#aboutUs" class="item">关于戎智</a>
								<a href="#ljrw" class="item">领军人才</a>
								<a href="#ywly" class="item">业务领域</a>
								<a href="#news" class="item">新闻中心</a>
							</div>
						</div>
					</div>
					<div class="col-6 col-sm-3" style="padding-left: 0;padding-right: 0;">
						<div class="title">联系我们</div>
						<div class="d-flex flex-column">
							<span class="m-b-20">电话：400-859-3991</span>
							<span>地址：南京市浦口区星火路19号星智汇商务花园14-2幢</span>
						</div>
					</div>
					<div class="col-sm-4 position-relative text-left ld-wrapper">
						<img src="./assets/imgs/foot_pic.png" class="pic position-absolute" alt="">
					</div>
				</div>
				<div class="row d-flex justify-content-center position-absolute cr w-100" style="padding: 10px 0;">
					<span>版权所有&nbsp;&copy;&nbsp; 南京戎智信息创新研究院有限公司</span>
					<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32011202000420"
						target="_blank">&nbsp;&nbsp;苏公网安备&nbsp;&nbsp;32011202000420</a>
					<a href="https://beian.miit.gov.cn/" target="_blank">
						&nbsp;&nbsp;苏ICP备20031558号-1
					</a>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	export default {
		data () {
			return {
				navs: [ {
						label: '首页',
						anchor: '#'
					}, {
						label: '关于戎智',
						anchor: '#aboutUs'
					}, {
						label: '领军人才',
						anchor: '#ljrw'
					}, {
						label: '业务领域',
						anchor: '#ywly'
					}, {
						label: '新闻中心',
						anchor: '#news'
					},
					{
						label: '联系我们',
						anchor: '#contact'
					}
				],
				banners: [
					"banner1.png",
					"banner2.png",
					"banner3.png"
				],
				scroll: 0,
				aboutH: 0,
				ljrcH: 0,
				ywlyH: 0,
				newsH: 0,
				concatH: 0,
				isActive: 0
			}
		},
		mounted () {
			this.$nextTick( () => {
				this.indexSwiper()
				this.newsSwiper()
				this.lySwiper()
				this.indexScroll()
				this.getNavHeight()
				window.addEventListener( "scroll", this.handleScroll )
			} )
		},
		unmounted () {
			window.removeEventListener( 'scroll', this.handleScroll )

		},
		methods: {
			handleNav(index){
				setTimeout(() => {
					this.isActive = index
				},100)
			},
			getNavHeight () {
				this.aboutH = document.querySelector( '.about-us' ).offsetTop -100
				this.ljrcH = document.querySelector( '.ljrw' ).offsetTop -100
				this.ywlyH = document.querySelector( '.ywly' ).offsetTop -100
				this.newsH = document.querySelector( '.news' ).offsetTop -100
				this.concatH = document.querySelector( '.contact' ).offsetTop -100
			},
			handleScroll () {
				var h = document.documentElement.scrollTop || document.body.scrollTop
				switch ( true ) {
					case h > this.concatH:
						this.isActive = 5
						break
					case h > this.newsH:
						this.isActive = 4
						break
					case h > this.ywlyH:
						this.isActive = 3
						break
					case h > this.ljrcH:
						this.isActive = 2
						break
					case h > this.aboutH:
						this.isActive = 1
						break
					default:
						this.isActive = 0
				}
			},
			bannerUrl ( item ) {
				return require( '@/assets/imgs/' + item )
			},
			indexScroll () {
				// 首页导航滚动事件
				$( window ).scroll( function () {
					headerBarInit();
				} );

				function headerBarInit ( a ) {
					if ( $( document ).scrollTop() > 50 ) {
						$( 'header' ).addClass( 'active' );
					} else {
						$( 'header' ).removeClass( 'active' );
					}
				}
			},
			indexSwiper () {
				new Swiper( '.index-swiper', {
					loop: true,
					autoplay: {
						disableOnInteraction: false
					},
					pagination: {
						el: '.swiper-pagination',
						clickable: true
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				} );
			},
			newsSwiper () {
				new Swiper( '.news-swiper', {
					loop: true,
					direction: "vertical",
					height: 310,
					slidesPerView: 3,
					mousewheel: true,
					pagination: {
						el: '.swiper-pagination',
						clickable: true
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				} );
			},
			lySwiper () {
				let innovateSwiper1 = new Swiper( '.innovate-swiper2', {
					loop: true,
					loopedSlides: 8,
					slidesPerView: 'auto',
					watchSlidesProgress: true,
					centeredSlides: true,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
					on: {
						progress: function ( progress ) {
							for ( let i = 0; i < this.slides.length; i++ ) {
								const slide = this.slides.eq( i );
								const slideProgress = this.slides[ i ].progress;
								const modify = Math.abs( slideProgress ) > 1 ? ( Math.abs( slideProgress ) -
										1 ) * 0.3 +
									1 : 1;

								var translate = slideProgress * modify * 180 + 'px';
								var scale = 1 - Math.abs( slideProgress ) / 5;
								slide.transform( 'translateX(' + translate + ') scale(' + scale + ')' );

								var zIndex = 999 - Math.abs( Math.round( 10 * slideProgress ) );
								slide.css( 'zIndex', zIndex );

								if ( Math.abs( slideProgress ) > 3 ) {
									slide.css( 'opacity', 0 );
								} else {
									slide.css( 'opacity', 1 ).children().css( 'opacity', 0.5 );
								}
							}
						},
						setTransition: function ( transition ) {
							for ( let i = 0; i < this.slides.length; i++ ) {
								this.slides.eq( i ).transition( transition );
							}
						}
					}
				} );
				$( '.innovate-swiper2 .swiper-slide' ).click( function () {
					const curIndex = $( '.innovate-swiper2 .swiper-slide' ).index( $(
						'.innovate-swiper2 .swiper-slide-active' ) );
					const clickIndex = $( '.innovate-swiper2 .swiper-slide' ).index( $( this ) );
					if ( curIndex < clickIndex ) {
						innovateSwiper1.slideNext();
					} else if ( curIndex > clickIndex ) {
						innovateSwiper1.slidePrev();
					}
				} );
			}
		}
	}
</script>
<style lang="less">

</style>
